if ("production" !== process.env.NODE_ENV) {
    console.warn("[mobx-react-lite] importing batchingForReactDom is no longer needed")
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/mobx-react-lite/batchingForReactDom.js
// module id = 623
// module chunks = 1